module.exports = __webpack_public_path__ + "img/delete-area-component.cbc3970b.png";